/* eslint-disable react/react-in-jsx-scope */
import { useEffect } from "react";
import { useNavigate, Outlet } from "react-router";
// import { useAuth } from "./AuthProvider";
import { useUserContext, useUserDispatch } from '../contexts/UserContext';
import { deCrypt } from "../api/enCrypt";
// import Footer from "./footer";
// import PosSidebar from "./PosSidebar";
// import Navbar from './landing/navbar'
//     import { Disclosure, DisclosureButton, DisclosurePanel, Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
//     import { Bars3Icon, BellIcon, XMarkIcon } from '@heroicons/react/24/outline'

    // const user = {
    //   name: 'Tom Cook',
    //   email: 'tom@example.com',
    //   imageUrl:
    //     'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    // }
    // const navigation = [
    //   { name: 'Dashboard', href: '#', current: true },
    //   { name: 'Team', href: '#', current: false },
    //   { name: 'Projects', href: '#', current: false },
    //   { name: 'Calendar', href: '#', current: false },
    //   { name: 'Reports', href: '#', current: false },
    // ]
    // const userNavigation = [
    //   { name: 'Your Profile', href: '#' },
    //   { name: 'Settings', href: '#' },
    //   { name: 'Sign out', href: '#' },
    // ]
    
    // function classNames(...classes) {
    //   return classes.filter(Boolean).join(' ')
    // }


const PrivateRoute = () => {
  // const user = useAuth();
  const user = useUserContext();
  const dispatch = useUserDispatch();
  const navigate = useNavigate();
  // const user = useUser();

  // console.log(user);    
  
  useEffect(() => {
      const token = sessionStorage.getItem("token");
    // if (!user.isLogin) {
      if(token) {
          // console.log(token);
          const data = JSON.parse(deCrypt(token));
          // console.log(data);
          dispatch({
            type: 'login',
            user: data,
          });
      } else navigate("/");
        // return;
  },[!user.isLogin])

  // console.log(user? user['email']: null);
  
  // const cu = JSON.parse(deCrypt(user.user));
  // console.log((cu));

  
  return (
    <>
      {user?.isLogin &&
        <div className="" >
          
          <Outlet />

        </div>
      }
    </>
  );
};

export default PrivateRoute;